<template>
    <div class="business">
        <Header></Header>
        <div class="business_container business_container_bg1">
            <div class="main_content">
                <div class="business_title">政务执法行业解决方案</div>
                <div class="business-bg1-box">
                    <div class="business-bg1-box-title">行业背景：</div>
                    <div class="business-bg1-box-text">
                        当前移动执法终端系统已覆盖公安、交通、环保、税务等多个场景，全球市场年复合增长率超 15%。这种“终端普及
                        + 网络升级 + 智能赋能”的技术环境，使得执法数据的现场采集、处理能力大幅提升，但同时也暴露出
                        “数据落地最后一公里”的短板——大量电子化信息需即时转化为纸质文书供当事人确认，传统手写或离线打印方式已无法匹配终端的智能化处理效率，热敏打印机成为衔接数字数据与实体文书的关键枢纽。
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_write">
            <div class="main_content">
                <div class="business-tabs">
                    <div class="business-tab" v-for="(tab, index) in tabList" :key="tab.title + index"
                         :class="{active: activeTabIndex === index}" @click="activeTabIndex = index">
                        <img v-if="index === 0" src="../images/icon1.png" alt="icon">
                        <img v-else-if="index === 1" src="../images/icon2.png" alt="icon">
                        <img v-else-if="index === 2" src="../images/icon3.png" alt="icon">
                        {{ tab.tabName }}
                    </div>
                </div>
                <div class="business_title">
                    {{ tabList[activeTabIndex].title }}
                </div>
                <div class="business_subtitle"> {{ tabList[activeTabIndex].subtitle }}</div>
                <div class="business-block" v-if="tabList[activeTabIndex].beds.length === 4">
                    <div class="business-block-item1">场景痛点</div>
                    <div class="business-block-item" v-for="(bed, index) in tabList[activeTabIndex].beds"
                         :key="bed.title+index">
                        <div class="business-block-item-title">{{ bed.title }}</div>
                        <div class="business-block-item-content">
                            <div class="business-block-item-text">{{ bed.text }}</div>
                            <img v-if="index === 0" class="business-block-item-img" src="../images/icon4.png"
                                 alt="img"/>
                            <img v-else-if="index === 1" class="business-block-item-img" src="../images/icon5.png"
                                 alt="img"/>
                            <img v-else-if="index === 2" class="business-block-item-img" src="../images/icon6.png"
                                 alt="img"/>
                            <img v-else-if="index === 3" class="business-block-item-img" src="../images/icon7.png"
                                 alt="img"/>
                        </div>
                    </div>
                </div>
                <div class="business-block2" v-else>
                    <div class="business-block-item1">场景痛点</div>
                    <div class="business-block-item" v-for="(bed, index) in tabList[activeTabIndex].beds"
                         :key="bed.title+index">
                        <div class="business-block-item-title">{{ bed.title }}</div>
                        <div class="business-block-item-text">{{ bed.text }}</div>
                        <img v-if="index===0" class="business-block-item-img" src="../images/icon4.png" alt="img"/>
                        <img v-else-if="index===1" class="business-block-item-img" src="../images/icon5.png" alt="img"/>
                        <img v-else-if="index===2" class="business-block-item-img" src="../images/icon6.png" alt="img"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_gray">
            <div class="main_content">
                <div class="business_title">解决方案</div>
                <div class="business_subtitle">{{ tabList[activeTabIndex].solution }}</div>
                <div class="business-solution-content" v-if="activeTabIndex === 0">
                    <img class="business-solution-content-printer-img" src="./images/KM360P.png"
                         alt="printer">
                    <div class="business-solution-content-printer">
                        <div class="business-solution-content-printer-title">
                            <span class="other-color">KM-360P</span>
                        </div>
                        <div class="business-solution-content-printer-subtitle">
                            小巧便携，持久续航可外出携带打印
                        </div>
                        <div class="business-solution-content-printer-list">
                            打印速度：80mm/s<br/>
                            分辨率：203dpi<br/>
                            支持纸张宽度：25~80mm<br/>
                            接口：蓝牙、NFC<br/>
                            日均打印量：500单<br/>
                            适用场景：警务执法、税务执法、市场执法等
                        </div>
                    </div>
                </div>
                <template v-else-if="activeTabIndex === 1">
                    <div class="business-solution-content">
                        <img class="business-solution-content-printer-img" src="./images/KM360P.png"
                             alt="printer">
                        <div class="business-solution-content-printer">
                            <div class="business-solution-content-printer-title">
                                <span class="other-color">KM-360P</span>
                            </div>
                            <div class="business-solution-content-printer-subtitle">
                                小巧便携，持久续航可外出携带打印
                            </div>
                            <div class="business-solution-content-printer-list">
                                打印速度：80mm/s<br/>
                                分辨率：203dpi<br/>
                                支持纸张宽度：25~80mm<br/>
                                接口：蓝牙、NFC<br/>
                                日均打印量：500单<br/>
                                适用场景：警务执法、税务执法、市场执法等
                            </div>
                        </div>
                    </div>
                    <div class="business-solution-content">
                        <div class="business-solution-content-printer">
                            <div class="business-solution-content-printer-title">
                                <span class="other-color">快麦A4</span> 打印机
                            </div>
                            <div class="business-solution-content-printer-subtitle">
                                外观便携小巧，支持自动进纸
                            </div>
                            <div class="business-solution-content-printer-list">
                                打印速度：15mm/s<br/>
                                分辨率：203dpi<br/>
                                支持纸张宽度：max214mm<br/>
                                接口：蓝牙、usb<br/>
                                打印续航能力（打印张数）：180张<br/>
                                适用场景：警务执法、税务执法、市场执法等
                            </div>
                        </div>
                        <img class="business-solution-content-printer-img" src="./images/A4.png"
                             alt="printer">
                    </div>
                    <div class="business-solution-content">
                        <img class="business-solution-content-gj-img" src="./images/bq.png" alt="printer">
                        <div class="business-solution-content-gj">
                            <div class="business-solution-content-gj-title">
                                <img src="../images/gj.png" alt="gj">
                                番茄标签
                            </div>
                            <div class="business-solution-content-gj-subtitle"></div>
                            <div class="business-solution-content-gj-kmy-text">
                                番茄标签编辑软件，覆盖电脑客户端、电脑网页版和App端，可免费编辑条码标签并支持多品牌机器打印。<br/><br/>
                                插入文本、条码、二维码、表格、图标等组件，智能排版；可上传excel、导入数据库等功能，设置自动序列号，可批量打印标签。<br/><br/>
                                番茄标签App搭配KM-360P便携打印机，能够提前制作好执法文书，执法时快速修改内容并连接打印机打印。<br/>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else-if="activeTabIndex === 2">
                    <div class="business-solution-content">
                        <img class="business-solution-content-printer-img" src="./images/A4.png"
                             alt="printer">
                        <div class="business-solution-content-printer">
                            <div class="business-solution-content-printer-title">
                                <span class="other-color">快麦A4</span> 打印机
                            </div>
                            <div class="business-solution-content-printer-subtitle">
                            </div>
                            <div class="business-solution-content-printer-list">
                                打印速度：15mm/s<br/>
                                分辨率：203dpi<br/>
                                支持纸张宽度：max214mm<br/>
                                接口：蓝牙、usb<br/>
                                打印续航能力（打印张数）：180张<br/>
                                适用场景：警务执法、税务执法、市场执法等
                            </div>
                        </div>
                    </div>
                    <div class="business-solution-content">
                        <div class="business-solution-content-gj">
                            <div class="business-solution-content-gj-title">
                                <img src="../images/gj.png" alt="gj">
                                番茄打印管家
                            </div>
                            <div class="business-solution-content-gj-subtitle"></div>
                            <div class="business-solution-content-gj-kmy-text">
                                番茄打印管家能够轻松管理打印机，支持自动安装打印机驱动并进行打印机管理，可设置打印浓度、速度、纸张尺寸等，实时监控打印任务和打印状态。<br/><br/>
                                配套的番茄标签编辑软件，支持插入文本、条码、二维码、表格、图标等组件，智能排版；支持标签批量打印，可上传excel、导入数据库等功能，设置自动序列号，可批量打印标签。<br/>
                            </div>
                        </div>
                        <img class="business-solution-content-gj-img" src="../images/gj-bg.png" alt="printer">
                    </div>
                </template>
            </div>
        </div>
        <div class="business_container business_container_white">
            <div class="main_content">
                <div class="business_title">方案优势</div>
                <div class="business-good">
                    <div class="business-good-item" v-for="(good, index) in tabList[activeTabIndex].goods"
                         :key="good.title + index">
                        <img v-if="index === 0" src="../images/icon8.png" alt="icon">
                        <img v-else-if="index === 1" src="../images/icon9.png" alt="icon">
                        <img v-else-if="index === 2" src="../images/icon10.png" alt="icon">
                        <img v-else-if="index === 3" src="../images/icon11.png" alt="icon">
                        <div class="business-good-item-title">{{ good.title }}</div>
                        <div class="business-good-item-text">{{ good.text }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_gray">
            <div class="main_content">
                <div class="business_title">场景典型客户案例</div>
                <div class="business-collaborative">
                    <template v-if="activeTabIndex === 0">
                        重庆交警 海南交警
                    </template>
                    <template v-else-if="activeTabIndex === 1">
                        太湖市场监督 重庆市场监督
                    </template>
                    <template v-else-if="activeTabIndex === 2">
                        衡阳税务 长沙税务
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../Header.vue';

export default {
    name: "YDZW",
    components: {Header},
    data() {
        return {
            activeTabIndex: 0,
            tabList: [
                {
                    tabName: '警务移动执法',
                    title: '警务移动执法',
                    subtitle: '警务移动执法是公安干警在非固定办公场所开展执法活动的核心模式，覆盖日常巡逻防控、现场案件处置、交通违法查处、社区警务服务等多元场景，具有即时性、流动性、复杂性三大核心特征，对执法文书的现场生成与交付提出极高要求',
                    solution: '部署便携式警务专用打印机，提升警务办公效率。',
                    beds: [
                        {
                            title: '文书处理',
                            text: '“即时性需求”与“滞后性输出”的矛盾'
                        },
                        {
                            title: '设备适配',
                            text: '“轻量化需求”与“笨重化设备”的冲突部分仓库环境恶劣，设备容易出故障，导致业务停摆；'
                        },
                        {
                            title: '环境适应',
                            text: '“复杂场景” 与 “设备脆弱性” 的落差'
                        },
                        {
                            title: '跨域协作',
                            text: '“数据共享” 与 “打印壁垒” 的阻碍'
                        },
                    ],
                    goods: [
                        {
                            title: '即时打印，高效执法',
                            text: '几秒钟可以完成执法文书打印，几分钟就可以完成一次执法'
                        },
                        {
                            title: '便携小巧，灵活执法',
                            text: '提高了执法的灵活性，对各类违法行为进行快速响应和处理'
                        },
                        {
                            title: '稳定可靠，精准执法',
                            text: '稳定的性能和高质量的打印效果，确保文书的准确性和完整性'
                        },
                        {
                            title: '数据互联，智能执法',
                            text: '数据的实时更新和共享，加强了执法的信息化和智能化水平'
                        },
                    ]
                },
                {
                    tabName: '市场监督管理执法',
                    title: '市场监督管理执法',
                    subtitle: '市场监督管理执法覆盖食品药品安全、特种设备监管、产品质量抽查、市场主体登记注册、价格监管、知识产权保护等多元场景，具有监管对象分散、执法场景多变、文书类型复杂、数据需即时归档四大核心特征。在315期间执法人员单日需走访10-20家市场主体，平均每处场所需出具2-3份文书，且部分场景（如农村小作坊、偏远山区药店）缺乏固定办公条件，需在户外或临时场所完成文书填写与交付。',
                    solution: '部署快麦便携式执法打印机、执法专用A4打印机和番茄标签软件，软硬件协同高效执法',
                    beds: [
                        {
                            title: '无法适应多场景执法',
                            text: '文书格式混乱，多场景适配难'
                        },
                        {
                            title: '人工效率低',
                            text: '人工记录误差大，档案归档效率低'
                        },
                        {
                            title: '无法跨区执法',
                            text: '多设备协同差，跨区域执法受限'
                        },
                    ],
                    goods: [
                        {
                            title: '文书自适配，操作更简单',
                            text: '执法人员可直接调用模板，填写关键信息后即时打印'
                        },
                        {
                            title: '数据实时上，档案秒归档',
                            text: '打印后自动生成电子档案，直接同步至市场监管档案系统'
                        },
                        {
                            title: '适配多环境，突破跨区域',
                            text: '打印机小巧便携容易携带，电池容量大持续不掉电'
                        },
                        {
                            title: '智能化管理，运维低压力',
                            text: '根据执法人员数量、执法频次灵活调配，监控设备状态'
                        },
                    ]
                },
                {
                    tabName: '税务稽查核查',
                    title: '税务稽查核查',
                    subtitle: '税务稽查核查是税务部门对企业纳税申报情况、税收缴纳合规性开展的专项执法工作，涵盖案头分析、实地检查、文书出具、后续追踪四大环节，具有跨区域协作频繁、文书类型严谨、数据安全要求高、执法流程规范的核心特征。文书需严格遵循国家税务总局统一格式，且涉及企业敏感纳税信息，不仅要求打印内容准确无误，还需保障数据传输与存储安全，避免信息泄露。',
                    solution: '部署快麦执法A4云打印机和番茄标签软件，打造专属移动政务协同办公体系',
                    beds: [
                        {
                            title: '异地打印同步难',
                            text: '异地数据割裂，文书打印难同步'
                        },
                        {
                            title: '人工易出错',
                            text: '文书格式严格，人工调整易出错'
                        },
                        {
                            title: '数据安全问题',
                            text: '数据安全风险高，打印环节难管控'
                        },
                    ],
                    goods: [
                        {
                            title: '异地打印',
                            text: '不管在哪里，都能打印，现场完成文书打印'
                        },
                        {
                            title: '同步打印',
                            text: '企业实地核查时，稽查人员通可边录入边打印，形成税务稽查工作底稿'
                        },
                        {
                            title: '信息加密',
                            text: '数据在传输与打印过程中全程加密，防止信息泄露'
                        },
                        {
                            title: '智能管理',
                            text: '配合番茄打印管家软件，实时监控设备状态，实现远程管理'
                        },
                    ]
                },
            ]
        }
    },
    mounted() {
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import "../business.scss";
</style>
